"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var rollbar_service_1 = require("./rollbar.service");
var RollbarModule = (function () {
    function RollbarModule() {
    }
    /**
     *
     * Setup the module in your application's root bootstrap.
     *
     * @static
     * @param {RollbarConfig} config The configuration for Rollbar logging
     * @returns {ModuleWithProviders} The module ready for your bootstrap
     *
     * @memberOf RollbarModule
     */
    /**
         *
         * Setup the module in your application's root bootstrap.
         *
         * @static
         * @param {RollbarConfig} config The configuration for Rollbar logging
         * @returns {ModuleWithProviders} The module ready for your bootstrap
         *
         * @memberOf RollbarModule
         */
    RollbarModule.forRoot = /**
         *
         * Setup the module in your application's root bootstrap.
         *
         * @static
         * @param {RollbarConfig} config The configuration for Rollbar logging
         * @returns {ModuleWithProviders} The module ready for your bootstrap
         *
         * @memberOf RollbarModule
         */
    function (config) {
        return {
            ngModule: RollbarModule,
            providers: [
                { provide: rollbar_service_1.ROLLBAR_CONFIGURATION, useValue: config }
            ],
        };
    };
    RollbarModule.decorators = [
        { type: core_1.NgModule, args: [{
                    providers: [
                        rollbar_service_1.RollbarService
                    ],
                },] },
    ];
    /** @nocollapse */
    RollbarModule.ctorParameters = function () { return []; };
    return RollbarModule;
}());
exports.RollbarModule = RollbarModule;
//# sourceMappingURL=rollbar.module.js.map